import axios from "axios";
import qs from "qs";

const HOST_API = "";

// ----------------------------------------------------------------------

const axiosInstance = axios.create({ baseURL: HOST_API });

axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem("controllerToken");
  const newConfig = config;
  if (token) {
    newConfig.headers.Authorization = token;
  }
  return newConfig;
});

axiosInstance.interceptors.response.use(
  (res) => res,
  (error) => Promise.reject((error.response && error.response.data) || "Something went wrong")
);

export default axiosInstance;

// ----------------------------------------------------------------------

export const fetcher = async (args) => {
  const [url, config] = Array.isArray(args) ? args : [args];

  const res = await axiosInstance.get(url, { paramsSerializer: params => qs.stringify(params, { arrayFormat: "repeat" }), ...config});

  return res.data;
};

// ----------------------------------------------------------------------

export const post = async (url, data) => {
  const res = await axiosInstance.post(url, data);
  return res.data;
};

// ----------------------------------------------------------------------

export const put = async (url, data) => {
  const res = await axiosInstance.put(url, data);
  return res.data;
}

// ----------------------------------------------------------------------

export const endpoints = {
  processes: {
    list: "/automation/api/processes_active",
    enable: (processCode) => `/automation/api/process/enable/${processCode}`,
    disable: (processCode) => `/automation/api/process/disable/${processCode}`,
  },
  configs: {
    list: (processCode) => `/automation/api/configs_by_process_code/${processCode}`,
    update: (configId) => `/automation/api/configs/${configId}`,
  },
  estimators: {
    list: "/automation/api/estimators_grouped_by_code",
    details: (code) => `/automation/api/estimator/${code}`,
    create: "/automation/api/estimators",
  },
  qrCode: "/automation/api/qrcode_url",
  camera: {
    list: "/camera/api/cams",
  },
  controller: {
    restart: "/automation/api/restart_controller",
  },
  steps: {
    pause: (process, step) => `/automation/api/shipment_process/${process}/${step}/action/pause`,
    resume: (process, step) => `/automation/api/shipment_process/${process}/${step}/action/resume`,
    abort: (process, step) => `/automation/api/shipment_process/${process}/${step}/action/abort`,
  }
};

